import { combineReducers } from 'redux';
import { handleActions, combineActions } from 'redux-actions';
import * as actionTypes from './constants';

export const data = handleActions(
  {
    [combineActions(
      actionTypes.GET_FUNCTIONAL_LOCATION_INFO_REQUEST,
      actionTypes.RESET_INFO,
    )]: () => ({}),
    [combineActions(
      actionTypes.GET_FUNCTIONAL_LOCATION_INFO_SUCCESS,
      actionTypes.SAVE_FUNCTIONAL_LOCATION_INFO_SUCCESS,
    )]: (state, { payload }) => payload.details.functionalLocation,
  },
  {},
);

export const lock = handleActions(
  {
    [combineActions(
      actionTypes.GET_FUNCTIONAL_LOCATION_INFO_REQUEST,
      actionTypes.RESET_INFO,
    )]: () => null,
    [combineActions(
      actionTypes.GET_FUNCTIONAL_LOCATION_INFO_SUCCESS,
      actionTypes.SAVE_FUNCTIONAL_LOCATION_INFO_SUCCESS,
      actionTypes.SAVE_FUNCTIONAL_LOCATION_INFO_FAILURE,
    )]: (state, { payload }) => payload.lock || null,
  },
  null,
);

export const lockingErrorType = handleActions(
  {
    [combineActions(
      actionTypes.GET_FUNCTIONAL_LOCATION_INFO_REQUEST,
      actionTypes.RESET_INFO,
    )]: () => null,
    [combineActions(
      actionTypes.GET_FUNCTIONAL_LOCATION_INFO_SUCCESS,
      actionTypes.SAVE_FUNCTIONAL_LOCATION_INFO_SUCCESS,
    )]: (state, { payload }) => payload.lockingErrorType,
  },
  null,
);

export const partners = handleActions(
  {
    [combineActions(
      actionTypes.GET_FUNCTIONAL_LOCATION_INFO_REQUEST,
      actionTypes.RESET_INFO,
    )]: () => [],
    [actionTypes.GET_FUNCTIONAL_LOCATION_INFO_SUCCESS]: (state, { payload }) => {
      const linkedPartners = payload.details.functionalLocation.partners;
      if (!linkedPartners || !payload.partners) {
        return state;
      }
      const partnerIds = linkedPartners?.map(p => p.number);
      return payload.partners?.filter(p => partnerIds.includes(p.number));
    },
  },
  [],
);

export const userStatuses = handleActions(
  {
    [combineActions(
      actionTypes.GET_FUNCTIONAL_LOCATION_INFO_REQUEST,
      actionTypes.RESET_INFO,
    )]: () => [],
    [actionTypes.GET_FUNCTIONAL_LOCATION_INFO_SUCCESS]: (state, { payload }) =>
      payload.userStatuses,
  },
  [],
);

export const taskLists = handleActions(
  {
    [combineActions(
      actionTypes.GET_FUNCTIONAL_LOCATION_INFO_REQUEST,
      actionTypes.RESET_INFO,
    )]: () => [],
    [actionTypes.GET_FUNCTIONAL_LOCATION_INFO_SUCCESS]: (state, { payload }) =>
      payload.taskLists,
  },
  [],
);

export const visitTypes = handleActions(
  {
    [combineActions(
      actionTypes.GET_FUNCTIONAL_LOCATION_INFO_REQUEST,
      actionTypes.RESET_INFO,
    )]: () => [],
    [actionTypes.GET_FUNCTIONAL_LOCATION_INFO_SUCCESS]: (state, { payload }) =>
      payload &&
      payload.taskLists &&
      payload.taskLists?.map(t => ({
        id: t.id,
        // eslint-disable-next-line max-len
        text: `${!t.isActive ? 'INACTIVE - ' : ''}${t.group.replace(/^0+/, '')}/${t.groupCounter} - ${t.description}${t.usage ? ` - ${t.usage}` : ''}`,
      })),
  },
  [],
);

export const isLoading = handleActions(
  {
    [actionTypes.GET_FUNCTIONAL_LOCATION_INFO_REQUEST]: () => true,
    [combineActions(
      actionTypes.GET_FUNCTIONAL_LOCATION_INFO_SUCCESS,
      actionTypes.GET_FUNCTIONAL_LOCATION_INFO_FAILURE,
      actionTypes.SAVE_FUNCTIONAL_LOCATION_INFO_REQUEST,
      actionTypes.SAVE_FUNCTIONAL_LOCATION_INFO_SUCCESS,
    )]: () => false,
  },
  false,
);

export const error = handleActions(
  {
    [combineActions(
      'LOCATION_CHANGE',
      actionTypes.GET_FUNCTIONAL_LOCATION_INFO_REQUEST,
      actionTypes.GET_FUNCTIONAL_LOCATION_INFO_SUCCESS,
      actionTypes.SAVE_FUNCTIONAL_LOCATION_INFO_REQUEST,
      actionTypes.SAVE_FUNCTIONAL_LOCATION_INFO_SUCCESS,
      actionTypes.RESET_INFO,
    )]: () => ({}),
    [combineActions(
      actionTypes.GET_FUNCTIONAL_LOCATION_INFO_FAILURE,
      actionTypes.SAVE_FUNCTIONAL_LOCATION_INFO_FAILURE,
    )]: (state, { payload }) => payload.error,
  },
  {},
);

export const isSaving = handleActions(
  {
    [combineActions(
      actionTypes.SAVE_FUNCTIONAL_LOCATION_INFO_REQUEST,
    )]: () => true,
    [combineActions(
      actionTypes.SAVE_FUNCTIONAL_LOCATION_INFO_SUCCESS,
      actionTypes.SAVE_FUNCTIONAL_LOCATION_INFO_FAILURE,
    )]: () => false,
  },
  false,
);

export const saveSuccess = handleActions(
  {
    [actionTypes.SAVE_FUNCTIONAL_LOCATION_INFO_SUCCESS]: () => true,
    [combineActions(
      actionTypes.SAVE_FUNCTIONAL_LOCATION_INFO_REQUEST,
      actionTypes.SAVE_FUNCTIONAL_LOCATION_INFO_FAILURE,
      actionTypes.RESET_SAVE_SUCCESS,
    )]: () => false,
  },
  false,
);

export const lockingErrors = handleActions(
  {
    [combineActions(
      actionTypes.GET_FUNCTIONAL_LOCATION_INFO_REQUEST,
      actionTypes.RESET_INFO,
    )]: () => [],
    [combineActions(
      actionTypes.GET_FUNCTIONAL_LOCATION_INFO_SUCCESS,
      actionTypes.SAVE_FUNCTIONAL_LOCATION_INFO_SUCCESS,
    )]: (state, { payload }) => payload.lockingErrors || [],
  },
  [],
);

export default combineReducers({
  data,
  isLoading,
  error,
  lock,
  lockingErrorType,
  partners,
  userStatuses,
  taskLists,
  visitTypes,
  isSaving,
  saveSuccess,
  lockingErrors,
});
